<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title">{{ title }}</h3>
    </div>
    <div class="panel-body" v-if="$slots.default">
      <slot></slot>
    </div>
    <div class="panel-body" v-if="rows.length === 0">
      <p class="text-muted">{{ emptyText }}</p>
    </div>
    <div v-else class="table-responsive">
      <table class="table table-striped table-hover" :data-testid="testId">
        <thead>
          <tr>
            <th v-for="column in nameColumns" :key="column.key">{{ column.label }}</th>
            <th>Orders</th>
            <th>Order Value</th>
            <th>{{ shareLabel }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td v-for="column in nameColumns" :key="column.key">{{ row[column.key] }}</td>
            <td>{{ row.orders.toLocaleString() }}</td>
            <td>{{ inDollars(row.order_value) }}</td>
            <td>{{ row.share_percent }}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { inDollars } from '../../../../DriveScout/Billing/Teller';

export default {
  name: 'MarketingBreakdownTable',
  props: {
    title: { type: String, required: true },
    testId: { type: String, required: true },
    rows: { type: Array, required: true },
    nameColumns: { type: Array, required: true },
    emptyText: { type: String, required: true },
    shareLabel: { type: String, default: 'Share' }
  },
  methods: {
    inDollars: inDollars
  }
};
</script>
